import { useQuery } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchNames: string;
}

export const searchReleasedBatchesByNames = async (batchNames: string): Promise<{ name: string; id: string; templateType: string; archived?: boolean }[]> => {
  try {
    return await request({
      path: `batches/search-released-batches-by-names`,
      method: 'POST',
      authenticate: true,
      dataObject: {
        names: batchNames,
      },
    });
  } catch (error) {
    showErrorToast(error, 'Error searching the batch name!');
  }
};

export const useReleasedBatchesByNames = ({ batchNames }: HookProps) =>
  useQuery({
    queryKey: ['batches', batchNames],
    queryFn: () => searchReleasedBatchesByNames(batchNames),
    placeholderData: [],
  });
